module.exports = __webpack_public_path__ + "static/media/menu.d6dec0bb.svg";